export class Snackbar {
	private toggleClass = 'is-active';
	private duration = 5000;

	constructor(private element: HTMLElement) {
		const btn = this.element.getElementsByClassName('js-snackbar-btn');
		if (btn && btn.length) {
			btn[0].addEventListener('click', () => {
				const snackbars = document.getElementsByClassName("js-snackbar-item");
				if (snackbars && snackbars.length) {
					const snackbar = snackbars[0];
					this.showSnackbar(snackbar);

					const close = snackbar.getElementsByClassName("js-snackbar-close");
					if (close && close.length) {
						close[0].addEventListener('click', () => {
							this.hideSnackbar(snackbar)
						});
					}
				}
			});
		}
	}

	private showSnackbar(snackbar: Element) {
		snackbar.classList.add(this.toggleClass);
		setTimeout(() => { this.hideSnackbar(snackbar) }, this.duration);
	}

	private hideSnackbar(snackbar: Element) {
		snackbar.classList.add('is-hidden');
		setTimeout(() => {
			snackbar.classList.remove('is-hidden')
			snackbar.classList.remove(this.toggleClass);
		}, 1000);
	}
}
